<template>
  <div class="d-flex justify-center align-center fill-height">
    <v-card class="d-flex radius_shadow ma-2" max-width="1300" height="96%">
      <Initial @next="next" />
    </v-card>
  </div>
</template>

<script>
import Initial from "./components/initial.vue";

export default {
  name: "start",

  components: { Initial },

  methods: {
    next(user) {
      localStorage.setItem("user", JSON.stringify(user));
      this.$router.push("simulation");
    },
  },
};
</script>

<style scoped>
.radius_shadow {
  border-radius: 25px !important;
  box-shadow: 40px 37px 20px rgba(0, 0, 0, 0.15) !important;
}
</style>